export const PACKAGE_MANAGEMENT_SECTIONS = {
  LIST_PACKAGES: 'LIST_PACKAGES',
  UPGRADE_PLAN_FORM: 'UPGRADE_PLAN_FORM',
}
